import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-13874d1a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "tasks-list-wrapper__line"
}

import { TaskList } from './';
import { DragModel } from '../../tir-pm-kanban';
import { computed, onMounted, PropType, ref } from 'vue';
import { TaskModel } from '../../tasks-kanban/models/TaskModel';
import { TasksKanbanGrouppingTypeEnum, TaskViewElementEnum } from '../../tasks-kanban/enums';
import { ListItemModel } from '../models';
import {
  TirPmButton,
  TirPmButtonSizeEnum,
  TirPmButtonVariantEnum,
  TirPmPagination,
} from 'tir-components';
import { TaskKanbanAdapterService } from '@/components/tasks-kanban/adapter';
import {
  GetTaskListRequestSortModel,
  GroupedTaskItemModel,
  GroupedTaskRequestModel,
  PageRequestModel,
} from '@/components/tasks-kanban/models';
import { useRoute } from 'vue-router';
import { PaginationRequestModel } from '@/models';
import GetAccessCurrentUserInQueueTaskByIdResponseModel from '../models/GetAccessCurrentUserInQueueTaskByIdResponseModel';

/**Параметры */
const DEFAULT_PAGE_STEP = 10;

/**Кол-во элементов на странице */

export default /*#__PURE__*/_defineComponent({
  __name: 'tasks-list-wrapper',
  props: {
  /**Задачи */
  tasks: { type: Array as PropType<TaskModel[]> },
  /** список тасков */
  group: { type: Object as PropType<GroupedTaskItemModel> },
  /**Тип группировки */
  grouppingType: { type: Number as PropType<TasksKanbanGrouppingTypeEnum> },
  /**Уровень вложенности */
  deepLevel: { type: Number, default: 0 },
  /**Размер имени задачи */
  nameWidth: { type: String },
  /**Размеры колонок списка */
  listColumns: { type: Array as PropType<ListItemModel[]> },
  /**Проверка кол-ва тасков */
  checkCountTasks: { type: Number as PropType<number> },
  /**Видимость данных группировки в карточке */
  visibleTaskGroupData: { type: Boolean, default: false },
  /**С какого уровня будут видны данные группировки в карточке */
  visibleTaskGroupDataStartLevel: { type: Number, default: 0 },
  /**Доступы юзера к очереди */
  userAccess: { type: Object as PropType<GetAccessCurrentUserInQueueTaskByIdResponseModel> },
  /**Критерии сортировки */
  sortingСriteria: { type: Object as PropType<GetTaskListRequestSortModel> },
},
  emits: ["dragComponentOnDrag", "dragComponentOnOver", "dragComponentOnDrop", "loadSubtasks", "open", "removeTask", "changeCountTasks"],
  setup(__props, { emit }) {

const props = __props;


/**События компонента */


/**API сервис */
const apiService = new TaskKanbanAdapterService();

/**Роут */
const route = useRoute();

/**Дефолтное кол-во элементов на странице */
const pageStep = ref(DEFAULT_PAGE_STEP);

/**Текущая страница */
const currentPage = ref<number>(1);

/** данные для отображения при перетаскивании */
const data = computed(() => {
  const isDrag = [
    TasksKanbanGrouppingTypeEnum.Status,
    TasksKanbanGrouppingTypeEnum.Priority,
    TasksKanbanGrouppingTypeEnum.Type,
  ].includes(props.grouppingType);

  return props.tasks?.map(
    (task) =>
      new DragModel({
        Data: task,
        AllowDrag: false,
        AllowDrop: true,
        IsDragging: false,
      }),
  );
});
/**Id текущей группы */
const groupId = computed(() => {
  switch (props.grouppingType) {
    case TasksKanbanGrouppingTypeEnum.Status:
      return props.group?.Status.Id;
    case TasksKanbanGrouppingTypeEnum.Performer:
      return props.group?.Performer.Id;
    case TasksKanbanGrouppingTypeEnum.Author:
      return props.group?.Author.Id;
    case TasksKanbanGrouppingTypeEnum.Priority:
      return props.group?.Priority.Id;
    case TasksKanbanGrouppingTypeEnum.Tag:
      return props.group?.Tag.Id;
    case TasksKanbanGrouppingTypeEnum.Type:
      return props.group?.Type.Id;
  }
});

/**Кол-во страниц */
const pagesCount = computed(() => {
  return Math.ceil(props.group?.Count / pageStep.value);
});

/**Заголовки списка */
const headers = computed(() => {
  return props.listColumns.map((x, i) => ({
    Name: x.Name,
    Style: {
      width: props.listColumns[i].Width,
      display:
        x.Type === TaskViewElementEnum.Status ||
        TaskViewElementEnum.Priority ||
        TaskViewElementEnum.WorkTime ||
        TaskViewElementEnum.EstimateTime
          ? 'flex'
          : 'block',
      justifyContent:
        x.Type === TaskViewElementEnum.Status
          ? 'flex-end'
          : x.Type === TaskViewElementEnum.Priority
          ? 'center'
          : x.Type === TaskViewElementEnum.EstimateTime
          ? 'flex-end'
          : x.Type === TaskViewElementEnum.WorkTime
          ? 'flex-end'
          : 'unset',
    },
  }));
});

/**Отображаемые элементы */
const viewElements = ref<Array<TaskViewElementEnum>>(Object.values(TaskViewElementEnum));

// /**Получить список задач группировок */
const getListTasksGroups = async (page?: PaginationRequestModel) => {
  const queueId = route.params.queueId;

  const response = await apiService.getTaskList(
    new GroupedTaskRequestModel({
      ParameterId: groupId.value,
      GrouppedBy: props.grouppingType,
      QueueTaskId: String(queueId),
      Sort: props.sortingСriteria,
      ViewSettings: {
        showNestedTasks: false,
        viewElements: viewElements.value,
      },
      Page: new PageRequestModel({
        Skip: page.Skip,
        Take: page.Take,
      }),
    } as any),
  );
  if (response.IsSuccess) {
    props.group.Items = response.Items;
  }
};

/**Изменить кол-во элементов на странице */
const changePageStep = async (value: number) => {
  pageStep.value = value;
  await getListTasksGroups(
    new PaginationRequestModel({
      Skip: 0,
      Take: pageStep.value,
    }),
  );
};

const changeCountTasks = () => {
  emit('changeCountTasks', 10);
};

/**Обновить текущую страницу */
const changeCurrentPage = async (value: number) => {
  currentPage.value = value;
  if (!pageStep.value) return;

  await getListTasksGroups(
    new PaginationRequestModel({
      Skip: pageStep.value * (value - 1),
      Take: pageStep.value,
    }),
  );
};

/** элемент над которым перетаскивается */
const dragComponentOnOver = (isOver: boolean, model: DragModel<TaskModel>) => {
  emit('dragComponentOnOver', isOver, model);
};

/** перетаскивание элемента */
const dragComponentOnDrag = (isDragging: boolean, model: DragModel<TaskModel>) => {
  emit('dragComponentOnDrag', isDragging, model);
};

/** сброс узла с тасками */
const dragComponentOnDrop = (model: DragModel<TaskModel>) => {
  emit('dragComponentOnDrop', model);
};

/**Стили элемента заголовка */
// const headersStyle = computed(() => ({ left: `calc(${props.nameWidth} + 2.5rem)` }));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value, (item, index) => {
      return (_openBlock(), _createBlock(_unref(TaskList), {
        class: "tasks-list-wrapper_block",
        key: index,
        userAccess: __props.userAccess,
        task: item,
        group: __props.group,
        "groupping-type": __props.grouppingType,
        deepLevel: __props.deepLevel,
        nameWidth: __props.nameWidth,
        listColumns: __props.listColumns,
        "visible-task-group-data": __props.visibleTaskGroupData,
        "visible-task-group-data-start-level": __props.visibleTaskGroupDataStartLevel,
        onOpen: _cache[0] || (_cache[0] = ($event: any) => (emit('open', $event))),
        onRemoveTask: _cache[1] || (_cache[1] = ($event: any) => (emit('removeTask', $event))),
        onDragComponentOnDrag: dragComponentOnDrag,
        onDragComponentOnOver: dragComponentOnOver,
        onDragComponentOnDrop: dragComponentOnDrop,
        onLoadSubtasks: _cache[2] || (_cache[2] = ($event: any) => (emit('loadSubtasks', $event)))
      }, null, 8, ["userAccess", "task", "group", "groupping-type", "deepLevel", "nameWidth", "listColumns", "visible-task-group-data", "visible-task-group-data-start-level"]))
    }), 128)),
    (
      __props.group?.Count > 10 && props.grouppingType !== _unref(TasksKanbanGrouppingTypeEnum).None && pagesCount.value
    )
      ? (_openBlock(), _createBlock(_unref(TirPmPagination), {
          key: 0,
          class: "tasks-list-wrapper__paginator",
          showMoreElements: "",
          pages: pagesCount.value,
          "range-size": 3,
          "model-value": currentPage.value,
          options: [10, 20, 30, 40, 50, 100],
          "count-elements": pageStep.value,
          "onUpdate:countElements": changePageStep,
          "onUpdate:modelValue": changeCurrentPage
        }, null, 8, ["pages", "model-value", "count-elements"]))
      : _createCommentVNode("", true),
    (__props.group?.Count > 10 && props.grouppingType !== _unref(TasksKanbanGrouppingTypeEnum).None)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1))
      : _createCommentVNode("", true)
  ], 64))
}
}

})